<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items" />-->
<!--    <router-view></router-view>-->

    <router-view v-slot="{ Component }">
      <keep-alive :include="['repair-request']">
        <component v-if="Component" :is="Component" />
      </keep-alive>
    </router-view>

  </Layout>
</template>

<script>
export default {
  data() {
    return {
      title: this.$t('menu.after-sales_service.service_request'),
      items: [
        {
          text: this.$t('menu.after-sales_service.text'),
          href: "/",
        },
        {
          text: this.$t('menu.after-sales_service.service_request'),
          active: true,
          href: "/repair-request/list",
        },
      ],
    };
  },
  components: {},
};
</script>

<style scoped lang='scss'>
</style>
